import { createContext } from 'react';

export const FilterFormCtx = createContext(null);
